import FormulateCssClassService from '@/Services/FormulateCssClassService/FormulateCssClassService';

class LabelCssClassService extends FormulateCssClassService {
    public process(): void {
        this.addNonGroupedClass([
            'text-gray-700',
            'text-2xl',
            'mb-4',
            'pr-6',
            'inline-block',
            'border-b-2'
        ])

        this.addGroupedClass([
            'text-lg'
        ])
    }
}

export default LabelCssClassService
